export const NAME_APPLICATION_ROUTES = {
  NAME_APPLICATION: 'name-application',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM_PAGE: 'form',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'summary',
};

export const ENTITY_REGISTRATION_ROUTES = {
  ENTITY_REGISTRATION: 'entity-registration',
  INSTRUCTION_PAGE: 'instruction',
  POSITION_HOLDER_PAGE: 'position-holder',
  CONSTITUTION_PAGE: 'constitution',
  ENTITY_INFO_PAGE: 'entity-info',
  SHARE_CAPITAL_PAGE: 'share-capital',
  SHARE_ALLOTMENT_PAGE: 'share-allotment',
  MODEL_CONSTITUTION_PAGE: 'constitutions',
  SELECTION_YRS: 'selection-years',
  REVIEW_PAGE: 'review',
  COMPLETION_PAGE: 'completion',
  SPECIAL_UEN: 'special-uen',
  PAYMENT_PAGE: 'payment',
};

export const ANNUAL_RETURNS_DECLARATIONS_ROUTES = {
  FILE_ARAD: 'entity-filing',
  INSTRUCTION_PAGE: 'instruction',
  DISPLAY_ENTITY_INFO: 'review-entity-info',
  ANNUAL_RETURNS: `annual-returns`,
  ANNUAL_DECLARATION: `annual-declaration`,
  COMPOSITION_SUM: `composition-sum`,
  AR_REVIEW_PAGE: 'annual-returns-review',
  AD_REVIEW_PAGE: 'annual-declaration-review',
  FINANCIAL_STATEMENTS: 'financial-statements',
  FINANCIAL_STATEMENTS_REVIEW: 'financial-statements-review',
  FINANCIAL_STATEMENTS_COMPLETION: 'financial-statements-completion',
  PAYMENT_PAGE: 'summary',
};

export const REDUCTION_SHARE_CAPITAL_ROUTES = {
  REDUCTION_SHARE_CAPITAL: 'reduction-share-capital',
  INSTRUCTION_PAGE: 'instruction',
  OVERVIEW_PAGE: 'overview',
  PUBLICATION: 'publication',
  RESOLUTION: 'resolution',
  CREDITOR_APPLICATION_FOR_CANCELLATION:
    'creditor-application-for-cancellation',
  CANCELLATION_WEBFORM: 'webform',
  CANCELLATION_REVIEW: 'review',
  WEB_FORM: 'webform',
  REVIEW: 'review',
  S78E_RSC_RESOLUTION: 'rsc-resolution',
  S78E_RSC_RESOLUTION_WEBFORM: 'rsc-resolution-webform',
  S78E_RSC_RESOLUTION_REVIEW: 'rsc-resolution-review',
  NOTICE_OF_COURT_ORDER: 'notice-of-court-order',
  COURT_ORDER_WEBFORM: 'court-order-webform',
  SHARES_WEB_FORM: 'shares-webform',
  S78E_RSC_RESOLUTION_SHARES_WEBFORM: 'rsc-resolution-shares-webform',
  NOTICE_OF_COURT_ORDER_WEBFORM: 'court-order-webform',
  SHARES_WEBFORM_S78G: 'notice-of-court-order-shares-webform',
  NOTICE_OF_COURT_ORDER_CANCELLATION_RESOLUTION:
    'court-order-cancellation-resolution',
  NOTICE_OF_COURT_ORDER_REVIEW: 'court-order-review',
  COMPLETION_PAGE: 'completion',
  PAYMENT_PAGE: 'payment',
};

export const MANAGE_ROUTES = {
  MANAGE: 'manage',
  ENTITY: 'entity',
};

export const UPDATE_PERSONNEL_ROUTES = {
  UPDATE_PERSONNEL: 'update-personnel',
  APPOINT_WITHDRAW_INSTRUCTION_PAGE:
    'appoint-withdraw-position-holder-instruction',
  APPOINT_WITHDRAW_FORM_PAGE: 'appoint-withdraw-position-holder-form',
  APPOINT_WITHDRAW_REVIEW_PAGE: 'appoint-withdraw-position-holder-review',
  EDIT_PERSONNEL_INSTRUCTION_PAGE: 'edit-position-holder-instruction',
  EDIT_PERSONNEL_FORM_PAGE: 'edit-position-holder-form',
  EDIT_PERSONNEL_REVIEW_PAGE: 'edit-position-holder-review',
  PAYMENT_PAGE: 'payment',
  COMPLETION_PAGE: 'completion',
};

export const CESSATION_DISSOLUTION_ROUTES = {
  CESSATION_DISSOLUTION: 'cessation-dissolution',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW_PAGE: 'review',
  COMPLETION_PAGE: 'completion',
  PAYMENT_PAGE: 'payment',
};

export const ENTITY_RENEWAL_ROUTES = {
  ENTITY_RENEWAL: 'entity-renewal',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM_PAGE: 'form',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'summary',
};

export const STRIKE_OFF_ROUTES = {
  STRIKE_OFF: 'strikeoff-business-entity',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  STRIKE_OFF_REVIEW: 'review',
  COMPLETION_PAGE: 'completion',
};

export const OBJ_STRIKING_OFF_ROUTES = {
  OBJ_STRIKING_OFF: 'objections-against-striking-off',
  INSTRUCTION_PAGE: 'instruction',
  FILE_NEW_OR_CLEAR_OBJ: 'file-new-or-clear-objection',
  FILE_NEW_OBJECTION: 'file-new-objection',
  CLEAR_OBJECTION: 'file-clear-objection',
  CLEAR_OBJECTION_REVIEW: 'clear-objection-review',
  OBJ_STRIKING_OFF_REVIEW: 'review',
  OBJ_STRIKING_OFF_COMPLETION: 'completion',
};

export const POST_STRIKE_OFF_ROUTES = {
  POST_STRIKE_OFF: 'post-initiation-strike-off',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW_PAGE: 'review-page',
  COMPLETION_PAGE: 'completion',
};

export const HOME = {
  HOME: 'home',
};

export const REGISTER_PUBLIC_ACCOUNTANT_ROUTES = {
  PUBLIC_ACCOUNTANT: 'registration-of-public-accountant',
  INSTRUCTION_PAGE: 'instruction',
  PERSONAL_PARTICULARS: 'personal-particulars',
  QUALIFICATIONS__PRACTICAL: 'qualifications-practical',
  PROFESSIONAL_EDUCATION: 'professional-education',
  MEMBERSHIP_DETAILS: 'membership-details',
  DECLARATION: 'declaration',
  EXEMPTIONS_PA: 'exemptions',
  REVIEW: 'review',
  PAYMENT: 'payment',
};

export const APPLICATION_FOR_FS_EXEMPTION_ROUTES = {
  APPLICATION_FOR_FS_EXEMPTION: 'application-for-fs-exemption',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'webform',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'payment',
  COMPLETION_PAGE: 'completion',
};

export const RENEW_PUBLIC_ACCOUNTANT_ROUTES = {
  PUBLIC_ACCOUNTANT: 'renewal-of-public-accountant',
  INSTRUCTION_PAGE: 'instruction',
  PERSONAL_PARTICULARS: 'personal-particulars',
  WEB_FORM: 'web-form',
  PAE_WEBFORM: 'public-accounting-entity-details',
  REVIEW: 'review',
  PROFESSIONAL_EDUCATION: 'professional-education',
  DECLARATION: 'declaration',
  CPE_EXEMPTION_WEBFORM: 'cpe-exemption',
};

export const REGISTER_CORPORATE_SERVICE_PROVIDER_ROUTES = {
  REGISTER_CSR: 'register-csp',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'payment',
};

export const REGISTER_QUALIFIED_INDIVIDUAL_ROUTES = {
  REGISTER_RQI: 'register-qualified-individual',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW: 'review',
  PAYMENT: 'payment',
  COMPLETION: 'completion',
};

export const UPDATE_SHAREHOLDER_ROUTES = {
  UPDATE_SHAREHOLDER: 'update-shareholder',
  INSTRUCTION_PAGE: 'instruction',
  FORM_PAGE: 'webform',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'payment',
  COMPLETION_PAGE: 'completion',
};

export const RENEW_CSP_ROUTES = {
  RENEW_CSP: 'renew-csp',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW_PAGE: 'review',
  PAYMENT: 'payment',
  COMPLETION_PAGE: 'completion',
};

export const RENEW_QUALIFIED_INDIVIDUAL_ROUTES = {
  RENEW_RQI: 'renew-qualified-individual',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW_PAGE: 'review',
  PAYMENT_PAGE: 'payment',
};

export const REGISTRATION_OF_CHARGES_ROUTES = {
  REGISTRATION_OF_CHARGES: 'registration-of-charges',
  INSTRUCTION_PAGE: 'instruction',
  WEBFORM_PAGE: 'webform',
  REVIEW: 'review',
  PAYMENT: 'payment',
};

export const INITIATION_OF_WINDING_UP_ROUTES = {
  INITIATION_OF_WINDING_UP: 'initiation-of-winding-up',
  INSTRUCTION_PAGE: 'instruction',
  WEB_FORM: 'web-form',
  REVIEW: 'review',
  COMPLETION: 'completion',
  PAYMENT: 'payment',
};

export const ALLOTMENT_OF_SHARES_ROUTES = {
  ALLOTMENT_OF_SHARES: 'allotment-of-shares',
  RETURN_OF_ALLOTMENT_OF_SHARES: 'return-allotment-of-shares',
  SHARE_CAPITAL: 'share-capital',
  SHAREHOLDERS: 'shareholders',
  SHARE_ALLOTMENT: 'share-allotment',
  REVIEW_AND_COMFIRM: 'review-confirm',
  COMPLETION_PAGE: 'completion',
};

export const POST_INITIATION_OF_WINDING_UP_ROUTES = {
  POST_INITIATION_OF_WINDING_UP: 'post-initiation-of-winding-up',
  INSTRUCTION_PAGE: 'instruction',
  WEBFORM: 'web-form',
  REVIEW: 'review',
  PAYMENT: 'payment',
  COMPLETION: 'completion',
};

export const MY_TRANSACTION_ROUTE = {
  MY_TRANSACTIONS: 'transactions',
  WITHDRAWAL: 'withdrawal',
};
export const VARIATION_SATISFACTION_ROUTES = {
  VARIATION_SATISFACTION: 'variation-satisfaction',
  INSTRUCTION: 'instruction',
  WEB_FORM: 'webform',
  REVIEW_PAGE: 'review',
  COMPLETION_PAGE: 'completion',
};

export const USEFUL_LINK_ROUTE = {
  VALUE_ADDED_SERVICES: 'value-added-services',
};

export const EMAIL_ROUTES = {
  EMAIL: 'email',
  VERIFY: 'verify/:transactionId',
  RESEND: 'resend/:correlationId',
};

export const TODO_ROUTES = {
  TODO: 'todo',
  PAYMENT_ROUTER_PAGE: 'payment/:referenceId',
  ENDORSEMENT: 'endorsement/:referenceId',
  ENDORSEMENT_RQI: 'endorsement/rqi/:referenceId',
  ENDORSEMENT_CSP: 'endorsement/csp/:referenceId',
  ENDORSEMENT_COMPLETION: 'endorsement/completion',
  CONSENT: 'consent/:referenceId',
  CONSENT_COMPLETION: 'consent/completion',
  GENERAL_LODGEMENT_PAYMENT_COLLECTION: 'general-lodgement/:referenceId',
  GENERAL_LODGEMENT_PAYMENT: 'Payment/:transactionId',
};

export const TRANSFER_OF_SHARES_ROUTES = {
  TRANSFER_OF_SHARES: 'transfer-of-shares',
  ADD_SHAREHOLDERS_AND_GROUP_SHARE: 'add-shareholders-group-share',
  SHARES_TRANSFER: 'share-transfer',
  REVIEW_AND_CONFIRM: 'review-confirm',
  COMPLETION: 'completion',
};

export const MAINTENANCE_OF_REGISTRABLE_CONTROLLERS_ROUTES = {
  MAINTENANCE_OF_RORC: 'maintenance-of-registrable-controllers',
  INSTRUCTION_PAGE: 'instruction',
  WEBFORM: 'web-form',
  REVIEW: 'review',
  COMPLETION: 'completion',
};

export const GENERAL_LODGEMENT_ROUTES = {
  GENERAL_LODGEMENT: 'general-lodgement',
  INSTRUCTION_PAGE: 'instruction',
  COMPLETION: 'completion',
  PAYMENT: 'payment',
  WEBFORM: 'webform',
  REVIEW: 'review',
  PAYMENT_LISTING: 'payment-listing',
  CREATE_PAYMENT: 'create-payment',
  SHARE_HOLDERS_AND_GROUP: 'share-holders-and-group-webform',
  SHARE_CAPITAL: 'share-capital',
  SHARE_HOLDING: 'share-holding',
};

export const COMMON_SHARES_ROUTE = {
  SHARES: 'shares',
};

export const UPDATE_ENTITY_ROUTES = {
  UPDATE_ENTITY: 'update-entity',
  REVIEW_BASIC_INFO: 'review-basic-information',
  REVIEW_BUSINESS_ACTIVITIES: 'review-business-activities',
  REVIEW_OFFICE_ADDRESS: 'review-office-address',
  REVIEW_REGISTERS_ADDRESS: 'review-registers-address',
  REVIEW_OFFICE_HOURS: 'review-office-hours',
  REVIEW_BRANCH_PARTICULARS: 'review-branch-particulars',
  REVIEW_CHARTER_INSTRUMENTS: 'review-csm-documents',
  PAYMENT_PAGE: 'payment',
  COMPLETION_PAGE: 'completion',
} as const;

export const WITHDRAW_APPLICATION_ROUTES = {
  WITHDRAWAL: 'withdrawal',
  FORM: 'form',
  WITHDRAWAL_COMPLETION_PAGE: 'completion',
};

export const MAINTENANCE_OF_CSP_CLIENT_LIST_ROUTES = {
  MAINTENANCE_OF_CSP_CLIENT_LIST: 'maintenance-of-csp-client-list',
  MY_CLIENT: 'my-client',
  MY_CSP: 'my-csp',
};

export const EXTENSION_OF_TIME_ROUTES = {
  EXTENSION_OF_TIME: 'extension-of-time',
  INSTRUCTION: 'instruction',
  WEB_FORM: 'form',
  REVIEW: 'review',
  PAYMENT_PAGE: 'payment',
  COMPLETION: 'completion',
};

export const FINANCIAL_YEAR_END_ROUTES = {
  FYE: 'financial-year-end',
  INSTRUCTION: 'instruction',
  WEBFORM: 'webform',
  REVIEW: 'review',
  COMPLETION: 'completion',
};

export const NOTICE_OF_ERROR_ROUTES = {
  NOE: 'notice-of-error',
  INSTRUCTION: 'instruction',
  TRANSACTION_SELECTION: 'transaction-selection',
  COMMON_WEBFORM: 'common-webform',
  AR_WEBFORM: 'ar-webform',
  SHARE_CAPITAL: 'share-capital-webform',
  SHARE_HOLDERS: 'share-holders-webform',
  SHARE_HOLDING: 'share-holding-webform',
  REVIEW: 'review',
  COMPLETION: 'completion',
  PAYMENT: 'payment',
};

export const NOMINATOR_INFORMATION_ROUTES = {
  UPDATE_NOMINATOR: 'update-of-nominee-directors-and-nominee-shareholders',
  INSTRUCTION: 'instruction',
  WEB_FORM: 'webform',
  REVIEW: 'review',
  COMPLETION: 'completion',
};
